import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface SessionContext {
  companyId:    string;
  companyCode:  string;
  companyName:  string;
  companyCurrency: string;

  locationId?:   string | null;
  locationCode?: string | null;
  locationName?: string | null;

  costCenterId?:   string | null;
  costCenterCode?: string | null;
  costCenterName?: string | null;

  financialYearId?:          string | null;
  financialYearCode?:        string | null;
  financialYearDescription?: string | null;

  financialPeriodId?:   string | null;
  financialPeriodCode?: string | null;
  financialPeriodName?: string | null;
}

interface SessionState {
  session: SessionContext | null;
}

const initialState: SessionState = { session: null };

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionContext>) => {
      state.session = action.payload;
    },

    updateSessionLocation: (
      state,
      action: PayloadAction<{ locationId?: string | null; locationCode?: string | null; locationName?: string | null }>
    ) => {
      if (state.session) {
        state.session.locationId   = action.payload.locationId;
        state.session.locationCode = action.payload.locationCode;
        state.session.locationName = action.payload.locationName;
      }
    },

    updateSessionCostCenter: (
      state,
      action: PayloadAction<{ costCenterId?: string | null; costCenterCode?: string | null; costCenterName?: string | null }>
    ) => {
      if (state.session) {
        state.session.costCenterId   = action.payload.costCenterId;
        state.session.costCenterCode = action.payload.costCenterCode;
        state.session.costCenterName = action.payload.costCenterName;
      }
    },

    updateSessionFinancialYear: (
      state,
      action: PayloadAction<{
        financialYearId?: string | null;
        financialYearCode?: string | null;
        financialYearDescription?: string | null;
      }>
    ) => {
      if (state.session) {
        state.session.financialYearId          = action.payload.financialYearId;
        state.session.financialYearCode        = action.payload.financialYearCode;
        state.session.financialYearDescription = action.payload.financialYearDescription;
      }
    },

    updateSessionFinancialPeriod: (
      state,
      action: PayloadAction<{
        financialPeriodId?: string | null;
        financialPeriodCode?: string | null;
        financialPeriodName?: string | null;
      }>
    ) => {
      if (state.session) {
        state.session.financialPeriodId   = action.payload.financialPeriodId;
        state.session.financialPeriodCode = action.payload.financialPeriodCode;
        state.session.financialPeriodName = action.payload.financialPeriodName;
      }
    },

    clearSession: (state) => {
      state.session = null;
    },
  },
});

export const {
  setSession,
  updateSessionLocation,
  updateSessionCostCenter,
  updateSessionFinancialYear,
  updateSessionFinancialPeriod,
  clearSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
